var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-contianer"},[_c('el-row',{attrs:{"gutter":12}},_vm._l((_vm.cardInfo),function(item){return _c('el-col',{key:item.title,staticClass:"card-item-self",attrs:{"span":6}},[_c('el-card',{attrs:{"shadow":"hover","body-style":{
					padding: '0px',
					height: '120px',
					textAlign: 'center', 
					cursor: 'pointer',
					backgroundColor: '#434A50',
					color: '#fff',
				}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(item.content))])])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }